diffQueryAgainstStore